import React from 'react';
import { connect } from 'react-redux';
import _find from 'lodash/find';
import PropTypes from 'prop-types';
// Models
import { title } from 'models/deviceModel';
// Custom
import { deviceModelDataShape } from 'constants/PropTypesShapes';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';

const DeviceModelIdDesc = ({ deviceModel }) => (
  <TruncatedTooltipText>
    {deviceModel ? title(deviceModel) : ''}
  </TruncatedTooltipText>
);

DeviceModelIdDesc.propTypes = {
  deviceModelId: PropTypes.number.isRequired, // eslint-disable-line react/no-unused-prop-types
  deviceModel: deviceModelDataShape,
};

DeviceModelIdDesc.defaultProps = {
  deviceModel: null,
};

const mapStateToProps = (state, ownProps) => ({
  loading: state.deviceModel.list.loading,
  deviceModel: _find(state.deviceModel.list.elements, ['id', ownProps.deviceModelId]),
});

module.exports = connect(mapStateToProps)(DeviceModelIdDesc);



// WEBPACK FOOTER //
// ./routes/app/routes/production/assets/deviceModel/DeviceModelIdDesc.js